import { garantia, clientePedido } from '@/apiClient/index'
import i18n from '../../plugins/i18n'

function initialState() {
  return {
    filtroSolicitudes: undefined
  }
}

const moduloSolicitudes = {
  namespaced: true,
  state: initialState,
  actions: {
    nuevaSolicitud(context, payload) {
      return new Promise(resolve => {
        garantia.post('/api/Garantias/AltaSolicitudServicio', payload)
        .then(response => resolve(response.data))
      })
    },

    getSolicitudes(context, payload) {
      
      // guardo los filtros de solicitudes
      context.commit('setFiltroSolicitudes', payload)
      
      // busco las solicitudes
      return new Promise((resolve) => {
        garantia.get('/api/Garantias/FindSolicitudesPaginated', { params: payload })
        .then(response => resolve(response.data))
      })
    },
    getSolicitud(context, payload) {
      return new Promise((resolve) => {
        garantia.get('api/Garantias/GetSolicitudServicio', { params: payload })
        .then(response => resolve(response.data))
      })
    },

    getImagen(context, payload) {
      return new Promise((resolve) => {
        garantia.get('api/Garantias/GetImagenSolicitudServicio', { params: payload })
        .then(response => resolve(response.data))
      })
    },
    uploadImagen(context, payload) {      
      // armo el payload
      let formData = new FormData()
      formData.append('imagen', payload.file)

      // subo el archivo
      return new Promise((resolve, reject) => {
        garantia.post(`/api/Garantias/UploadImagenSolicitudServicio?solicitudId=${payload.id}&numeroArchivo=${payload.numeroArchivo}`, formData)
        .then(
          response => { resolve(response.data) },
          error => { reject(error) }
        )
      })
    },
    editarSolicitud(context, payload) {
      return new Promise((resolve) => {
        garantia.post('api/Garantias/EditarSolicitudServicio', payload)
        .then(response => resolve(response.data))
      })
    },
    anularSolicitud(context, payload) {
      
      return new Promise(resolve =>{
        garantia.post(`/api/Garantias/AnularSolicitud?solicitudId=${payload.solicitudId}`)
        .then(response => resolve(response.data))
      })
    },
    borrarSolicitud(context, payload) {
      
      return new Promise(resolve =>{
        garantia.post(`/api/Garantias/BorrarSolicitud?solicitudId=${payload.solicitudId}`)
        .then(response => resolve(response.data))
      })
    },
    asociarSolicitudes(context, payload) {
      
      return new Promise(resolve => {
        garantia.post(`/api/Garantias/asociarRemito`, payload)
        .then(response => resolve(response.data))
      })
    },

    desasociarRemito(context, payload) {
      return new Promise(resolve => {
        garantia.post(`/api/Garantias/desasociarRemito`, payload)
        .then(response => resolve(response.data))
      })
    },
    
    getDescripcion(context, payload) {

      return new Promise(resolve => {
        garantia.get(`/api/Garantias/ObtenerDescripcion?identificadorElemento=${payload.identificadorElemento}`)
        .then(response =>  resolve(response.data))
      })
    },

    getMotivos(context, payload) {
      return new Promise(resolve => {
        garantia.get(`/api/Garantias/BuscarMotivos`)
        .then(response =>  resolve(response.data))
      })
    },
    
    getEsCanjeable(context, payload) {
      return new Promise(resolve => {
        garantia.get(`/api/Garantias/EsCanjeable?p_NS=${payload.p_NS}&p_Clild=${payload.p_Clild}`)
          .then(response => resolve(response.data))
      })
    },

    getRemitosFirmar(context, payload) {
      return new Promise(resolve => {
        clientePedido.get('/api/Remitos/GetListadoRemitos', { 
          params: {
            page: payload.page,
            pageSize: payload.pageSize,
            usuarioId: payload.usuarioId,
            numero: payload.numero || undefined,
            firmado: payload.firmado
          }
        })
        .then(response => {
          // Mapear respuesta del backend al formato esperado por el front
          const datos = response.data.Datos;
          
          if (!datos || !datos.Remitos) {
            console.warn('getRemitosFirmar: estructura de datos inesperada', datos);
            resolve({
              CodigoResultado: response.data.CodigoResultado,
              MensajeError: response.data.DescripcionResultado,
              Datos: {
                TotalPaginas: 0,
                Remitos: []
              }
            });
            return;
          }
          
          resolve({
            CodigoResultado: response.data.CodigoResultado,
            MensajeError: response.data.DescripcionResultado,
            Datos: {
              TotalPaginas: datos.TotalPaginas,
              Remitos: datos.Remitos.map(r => {
                const estadoRaw = r.EstadoFirma;
                let firmadoFlag = false;
                if (typeof estadoRaw === 'string') {
                  firmadoFlag = estadoRaw.toLowerCase() === 'z' || estadoRaw.toUpperCase() === 'Z';
                }

                // Fallback: si backend provee un campo booleano explícito
                if (!firmadoFlag && (r.Firmado === true || r.Firmado === 'true')) {
                  firmadoFlag = true;
                }

                return {
                  Id: r.Id,
                  Fecha: r.Fecha,
                  Tipo: r.Tipo,
                  Serie: r.Serie,
                  PV: r.PuntoVenta,
                  Nro: r.Numero,
                  CantidadItems: r.CantidadItems || 0,
                  Firmado: firmadoFlag,
                  FirmaConforme: r.FIRMA_CONFORME || r.FirmaConforme || '',
                  Estado: estadoRaw,
                  Por: r.FirmadoPor || '',
                  El: r.FechaFirma,
                  FirmaNotas: r.Notas || '',
                  NumeroRemito: `${r.Tipo}-${r.Serie}-${r.PuntoVenta}-${r.Numero}`
                };
              })
            }
          });
        })
        .catch(error => {
          console.error('Error en getRemitosFirmar:', error);
          resolve({
            CodigoResultado: -1,
            MensajeError: i18n.t('FIRMAR_REMITOS_error_cargar'),
            Datos: {
              TotalPaginas: 0,
              Remitos: []
            }
          });
        })
      })
    },

    getRemitoPDF(context, payload) {
      return new Promise((resolve, reject) => {
        clientePedido.get(`/api/Remitos/GetRemitoPDF`, {
          params: {
            id: payload.remitoId,
            usuarioId: payload.usuarioId
          },
          responseType: 'blob'
        })
        .then(response => {
          // Crear URL temporal para descarga
          const blob = new Blob([response.data], { type: 'application/pdf' });
          const url = window.URL.createObjectURL(blob);
          
          // Obtener nombre del archivo del header (si existe)
          const contentDisposition = response.headers['content-disposition'];
          let fileName = `remito-${payload.remitoId}.pdf`;
          if (contentDisposition) {
            const fileNameMatch = contentDisposition.match(/filename="?(.+)"?/);
            if (fileNameMatch && fileNameMatch[1]) {
              fileName = fileNameMatch[1];
            }
          }
          
          resolve({ url, fileName });
        })
        .catch(error => {
          console.error('Error en getRemitoPDF:', error);
          reject({
            CodigoResultado: -1,
            MensajeError: i18n.t('FIRMAR_REMITOS_error_descargar')
          });
        })
      })
    },

    firmarRemito(context, payload) {
      return new Promise((resolve, reject) => {
        clientePedido.post('/api/Remitos/FirmarRemito', {
          RemitoId: payload.remitoId,
          UsuarioId: payload.usuarioId,
          Notas: payload.notas || '',
          p_conforme: payload.conforme,
          Conforme: payload.conforme
        })
        .then(response => resolve(response.data))
        .catch(error => {
          console.error('Error en firmarRemito:', error);
          reject({
            CodigoResultado: -1,
            MensajeError: i18n.t('FIRMAR_REMITOS_error_firmar')
          });
        })
      })
    },
  },
  mutations: {
    setFiltroSolicitudes(state, payload) {
      state.filtroSolicitudes = payload
    }
  }
}

export default moduloSolicitudes